const certifications = [
  { name: '國際規範認證', desc: '符合國際優良製造規範', icon: 'ri-award-line' },
  { name: 'ISO 22000', desc: '食品安全管理系統', icon: 'ri-shield-check-line' },
  { name: 'HACCP', desc: '危害分析重要管制點', icon: 'ri-scan-line' },
  { name: 'SGS 檢驗', desc: '第三方安全檢驗認證', icon: 'ri-verified-badge-line' },
];

const qcSteps = [
  { icon: 'ri-truck-line', num: '01', title: '原料進廠驗收', desc: '每批原料入廠進行外觀、成分含量、微生物、重金屬等多項檢測，不合格批次一律退回。' },
  { icon: 'ri-settings-3-line', num: '02', title: '製程監控管理', desc: '生產全程監控重量差異、崩散度、硬度等關鍵品質指標，異常立即停線處理。' },
  { icon: 'ri-flask-line', num: '03', title: '半成品中間管控', desc: '每個製程節點均進行中間管控檢查，確保半成品符合規格後方可進入下一製程。' },
  { icon: 'ri-test-tube-line', num: '04', title: '成品全項檢驗', desc: '出貨前進行完整成品檢驗，包含微生物、農藥、重金屬、標示符合性等全面查核。' },
  { icon: 'ri-file-check-line', num: '05', title: '出具檢驗報告', desc: '每批次附完整 Certificate of Analysis（CoA），供客戶存檔及市場查核使用。' },
];

export default function QualitySection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            品質管理
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">嚴格品管，每批次安全有保障</h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技建立完整的品質管理體系，從原料到成品全程把關，確保產品安全合規
          </p>
        </div>

        {/* Certifications */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
          {certifications.map((cert) => (
            <div key={cert.name} className="bg-[#f7faf7] rounded-2xl p-6 text-center border border-gray-100 hover:border-green-200 transition-all duration-300">
              <div className="w-14 h-14 flex items-center justify-center bg-green-50 rounded-xl mx-auto mb-4 border border-green-100">
                <i className={`${cert.icon} text-[#4CAF50] text-2xl`} />
              </div>
              <h3 className="text-[#1a2e1a] font-bold text-[1rem] mb-1">{cert.name}</h3>
              <p className="text-gray-400 text-[0.8125rem]">{cert.desc}</p>
            </div>
          ))}
        </div>

        {/* QC steps */}
        <div className="bg-[#f7faf7] rounded-2xl p-8 lg:p-10 border border-gray-100">
          <h3 className="text-[#1a2e1a] font-bold text-[1.25rem] mb-2 text-center">五階段品質管理流程</h3>
          <p className="text-gray-500 text-[0.9375rem] mb-10 text-center">從原料進廠到成品出貨，每個環節都有嚴格的品管機制把關</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {qcSteps.map((step) => (
              <div key={step.title} className="relative flex flex-col items-center text-center">
                <div className="relative mb-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full border-2 border-[#4CAF50]">
                    <i className={`${step.icon} text-[#4CAF50] text-2xl`} />
                  </div>
                  <span className="absolute -top-2 -right-2 w-7 h-7 flex items-center justify-center bg-[#4CAF50] text-white text-[0.6875rem] font-bold rounded-full whitespace-nowrap">
                    {step.num}
                  </span>
                </div>
                <h4 className="text-[#1a2e1a] font-bold text-[0.9375rem] mb-2">{step.title}</h4>
                <p className="text-gray-500 text-[0.8125rem] leading-[1.75]">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}